import { render } from "./tree-option.vue?vue&type=template&id=5bb8f5e6&scoped=true"
import script from "./tree-option.vue?vue&type=script&lang=js"
export * from "./tree-option.vue?vue&type=script&lang=js"

import "./tree-option.vue?vue&type=style&index=0&id=5bb8f5e6&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb8f5e6"]])

export default __exports__